import type { FC, SVGAttributes } from 'react';

const IconDivan: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.6005 11.7171C4.84926 12.0483 5.31941 12.1151 5.6506 11.8663C5.9818 11.6176 6.04861 11.1474 5.79985 10.8162L4.6005 11.7171ZM4.45017 22.4666C4.45017 22.8809 4.78596 23.2166 5.20017 23.2166C5.61438 23.2166 5.95017 22.8809 5.95017 22.4666H4.45017ZM24.05 22.4666C24.05 22.8809 24.3858 23.2166 24.8 23.2166C25.2142 23.2166 25.55 22.8809 25.55 22.4666H24.05ZM1.75 18.2666V12.6666H0.25V18.2666H1.75ZM3.33333 19.85C2.45888 19.85 1.75 19.1411 1.75 18.2666H0.25C0.25 19.9695 1.63046 21.35 3.33333 21.35V19.85ZM3.33333 9.58331C1.63046 9.58331 0.25 10.9638 0.25 12.6666H1.75C1.75 11.7922 2.45888 11.0833 3.33333 11.0833V9.58331ZM3.33333 11.0833C3.85086 11.0833 4.31036 11.3308 4.6005 11.7171L5.79985 10.8162C5.23859 10.069 4.34257 9.58331 3.33333 9.58331V11.0833ZM3.33333 21.35H5.20017V19.85H3.33333V21.35ZM4.45017 20.6V22.4666H5.95017V20.6H4.45017ZM5.20017 21.35H24.8V19.85H5.20017V21.35ZM24.8 21.35H26.6667V19.85H24.8V21.35ZM24.05 20.6V22.4666H25.55V20.6H24.05ZM28.25 12.6666V18.2666H29.75V12.6666H28.25ZM28.25 18.2666C28.25 19.1411 27.5411 19.85 26.6667 19.85V21.35C28.3695 21.35 29.75 19.9695 29.75 18.2666H28.25ZM26.6667 11.0833C27.5411 11.0833 28.25 11.7922 28.25 12.6666H29.75C29.75 10.9638 28.3695 9.58331 26.6667 9.58331V11.0833ZM26.6667 9.58331C25.6576 9.58331 24.7617 10.0689 24.2004 10.8159L25.3996 11.7169C25.6898 11.3307 26.1492 11.0833 26.6667 11.0833V9.58331Z'
        fill='#404040'
      />
      <path
        d='M7.5332 8.28333H22.4668C23.5989 8.28333 24.5165 9.20104 24.5166 10.3331V15.4708H5.4834V10.3331C5.4835 9.20114 6.40118 8.28346 7.5332 8.28333Z'
        stroke='#404040'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export default IconDivan;
